import axios from "axios";
import { SuperAdminURL } from "../../../../config/UrlEndPoint";

export const URL = `${SuperAdminURL}organization/`;

//  * FIND ORGANIZATION REPORT
export function findOrganizationReport(queryParams) {
  return axios.post(`${URL}find_report`, queryParams);
}
// * UPDATE STATUS ORGANIZATION REPORT
export function createOrganizationReport(payload) {
  return axios.put(`${URL}update_status_report`, payload);
}
//  * GET ORGANIZATION REPORT BY ID
export function getOrganizationReportById(uuid) {
  return axios.get(`${URL}organization_report/${uuid}`);
}
